import { defaultCountries, parseCountry } from "react-international-phone";

// ISO2 codes of the 54 African countries seeded in UtilityConfigurations (SeedAfricanCountriesAndCurrencies).
const AFRICAN_COUNTRY_CODES = [
	"ao", "bf", "bi", "bj", "bw", "cd", "cf", "cg", "ci", "cm",
	"cv", "dj", "dz", "eg", "er", "et", "ga", "gh", "gm", "gn",
	"gq", "gw", "ke", "km", "lr", "ls", "ly", "ma", "mg", "ml",
	"mr", "mu", "mw", "mz", "na", "ne", "ng", "rw", "sc", "sd",
	"sl", "sn", "so", "ss", "st", "sz", "td", "tg", "tn", "tz",
	"ug", "za", "zm", "zw",
];

export const africanCountries = defaultCountries.filter(country => AFRICAN_COUNTRY_CODES.includes(parseCountry(country).iso2));
